<template>
    <div class="div" v-if="journey">
        <google-map :polylines="polylines" :inverted="inverted" :markers="markers">
        </google-map>
    </div>
</template>
<script>
import GoogleMap from '@/components/Map.vue'
import { stageTypeMarkerIcon } from '@/store/mapOptions'
import { mapGetters } from 'vuex'

export default {
    props: ['journey', 'type'],
    components: {
        'google-map': GoogleMap,
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters([
            'getMapIconByTransportMode',
        ]),
        polylines() {
            if (this.type === 'both') {
                return [this.journey.depart.overview_polyline, this.journey.return.overview_polyline]
            }
            return [this.journey[this.type].overview_polyline]
        },
        inverted() {
            return this.type === 'return'
        },
        markers() {
            const markers = []
            const steps = this.type === 'both' ? [...this.journey.depart.steps, ...this.journey.return.steps] : this.journey[this.type].steps
            steps.forEach((step) => {
                markers.push({
                    position: step.start_location,
                    icon: {
                        ...stageTypeMarkerIcon,
                        url: this.getMapIconByTransportMode(step.type),
                    },
                })
            })
            return markers
        },
    },
}
</script>
